import baseFetch, { createParamString } from '../baseFetch';

export const fetchRegionalOverview = subregionId =>
  baseFetch(`/kbyg/regions/overview?subregionId=${subregionId}`);

export const fetchRegionalArticles = async subregionId =>
  baseFetch(`/feed/regional?${createParamString({ subregionId })}`);



// WEBPACK FOOTER //
// ./src/common/api/region.js